// Whose money the chat talks about. The chat is tied to the workspace selected
// in the app, and the person typing is not always its Owner: the Owner reads
// "your money", everyone else reads the Owner's first name ("Juan's money"),
// matching what the assistant itself says. Null means the "your" copy: the
// reader owns the workspace, or the owner has no usable first name.
export const chatOwnerName = (workspace) => {
  if (!workspace || workspace.workspace_role === 'Owner') return null;
  return workspace.owner_first_name || null;
};
